export const optionStyles = {
  divider: { marginLeft: "2rem", color: "grey", fontSize: ".8rem" },
};
